import type { RadarLocale } from './radarLanding';

export function saveRadarLocale(locale: RadarLocale) {
  try { localStorage.setItem('radar.locale', locale); } catch { /* Storage can be unavailable. */ }
}

export function preferredRadarLocale(): RadarLocale {
  try {
    const saved = localStorage.getItem('radar.locale');
    if (saved === 'en' || saved === 'zh-Hans' || saved === 'zh-Hant') return saved;
  } catch { /* Fall back to browser language. */ }
  const language = typeof navigator === 'undefined' ? 'en' : navigator.language;
  if (/^zh-(TW|HK|MO|Hant)/i.test(language)) return 'zh-Hant';
  return /^zh/i.test(language) ? 'zh-Hans' : 'en';
}
